import classNames from 'classnames'
import { t } from 'i18next'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import {
  getFormErrorMessage,
  getRequiredFormMessage,
} from '../../../util/ErrorText'

export const GroupForm = (props: { disabled: boolean }): JSX.Element => {
  const { control, formState } = useFormContext()
  return (
    <>
      <div className="field col ml-0 pl-0">
        <label
          htmlFor="group_name"
          className={classNames(
            { 'p-error': formState.errors.group_name },
            ' '
          )}
        >
          {t<string>('hrm.group.group_name')}
        </label>
        <Controller
          name="group_name"
          control={control}
          rules={{
            required: getRequiredFormMessage('hrm.group.group_name'),
            maxLength: 100,
          }}
          render={({ field, fieldState }) => (
            <InputText
              disabled={props.disabled}
              id={field.name}
              {...field}
              value={field.value || ''}
              maxLength={100}
              className={classNames(
                { 'p-invalid': fieldState.error },
                ' w-full people-dropdown'
              )}
            />
          )}
        />
        {getFormErrorMessage(formState.errors, 'group_name')}
      </div>
      <div className="field col  ml-0 pl-0">
        <label
          htmlFor="name"
          className={classNames(
            { 'p-error': formState.errors.group_description },
            ' '
          )}
        >
          {t<string>('hrm.group.description')}
        </label>

        <Controller
          name="group_description"
          control={control}
          rules={{
            required: getRequiredFormMessage('hrm.group.description'),
            maxLength: 500,
          }}
          render={({ field, fieldState }) => (
            <InputTextarea
              disabled={props.disabled}
              id={field.name}
              rows={1}
              {...field}
              maxLength={500}
              value={field.value || ''}
              className={classNames(
                { 'p-invalid': fieldState.error },
                ' w-full people-dropdown '
              )}
            />
          )}
        />
        {getFormErrorMessage(formState.errors, 'group_description')}
      </div>
    </>
  )
}